import React, { memo, useMemo } from 'react';
import { useObservable } from 'react-use-observable';

import { EFinancialStatementTabs } from 'v2/interfaces/financial';
import { financialStatementService } from 'v2/services/financialStatement/statement';

import ContentTable from '../ContentTable';

function Statement() {
  useObservable(() => financialStatementService.loadData(), []);

  const [entries] = useObservable(() => financialStatementService.getFinancialStatement(), [], []);
  const [pagination] = useObservable(() => financialStatementService.getPaginationResponse(), []);
  const [isLoading] = useObservable(() => financialStatementService.isLoading(), []);

  const handlePagination = useMemo(
    () => ({
      onChangeRowsPerPage: (perPage: number) => {
        financialStatementService.setPagination({ ...pagination, ...{ per_page: perPage, current_page: 1 } });
        document.getElementById('statement_table').scrollIntoView();
      },
      onChangePage: (page: number) => {
        financialStatementService.setPagination({ ...pagination, ...{ current_page: page } });
        document.getElementById('statement_table').scrollIntoView();
      }
    }),
    [pagination]
  );

  return (
    <ContentTable
      id='statement_table'
      currentTab={EFinancialStatementTabs.STATEMENT}
      balanceLabel='Saldo'
      data={entries}
      pagination={pagination}
      handlePagination={handlePagination}
      loading={isLoading}
    />
  );
}

export default memo(Statement);
